<template>
  <div class="fill-height back ma-6 justify-center align-content-center text-center">
    <v-layout align-center justify-center>

      <v-card width="500px" elevation="1" class="center justify-center text-center">
        <div>
          <img width="200px" class="text-center" max-width="150" max-height="150" src="https://cdn.irscloud.id/logo/close.png">
        </div>
        <v-card-text>
          <p class="title green--text">Pembayaran Gagal dilakukan</p>
        </v-card-text>
        <v-card-actions>
          <v-btn class="red text" @click="selanjutnya" block elevation="0">Lobby</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'PaymentTopupFailed',
  data: () => ({
    inv: ''
  }),
  methods: {
    selanjutnya () {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>

</style>
